import moment from "moment";
import { isPaidUser, isUsageUser } from "utils/common";
import { create } from "zustand";

export const usePaymentChartData = create()((set, get) => ({
  daysData: {},
  setDaysData: (value) => set({ daysData: value }),
  stats: { total: 0, paid: 0, unpaid: 0 },
  setStats: (value) => set({ stats: value }),
  chartData: [],
  setChartData: (value) => set({ chartData: value }),
  lastUserId: null,
  setLastUserId: (value) => set({ lastUserId: value }),
  loading: false,
  setLoading: (value) => set({ loading: value }),
  onReset: () => set((state) => ({
    daysData: {},
    stats: { total: 0, paid: 0, unpaid: 0 },
    chartData: [],
    lastUserId: null,
    loading: false
  })),
  updatePaymentStatsByUserChange: (oldUser, newUser) => {
    const store = get();
    const dateKey = moment(newUser.createdAt).format("YYYY-MM-DD");

    const daysData = { ...store.daysData };
    const stats = { ...store.stats };

    if (!daysData[dateKey]) {
      daysData[dateKey] = { payUsers: 0, unpayUsers: 0, totalUsers: 0 };
    }

    const wasPaid = isPaidUser(oldUser);
    const isPaid = isPaidUser(newUser);

    if (wasPaid !== isPaid) {
      if (wasPaid && !isPaid) {
        daysData[dateKey].payUsers--;
        daysData[dateKey].unpayUsers++;
        stats.paid--;
        stats.unpaid++;
      } else if (!wasPaid && isPaid) {
        daysData[dateKey].payUsers++;
        daysData[dateKey].unpayUsers--;
        stats.paid++;
        stats.unpaid--;
      }
    }

    set({ daysData, stats });
  },
  removeUserFromPaymentStats: (user) => {
    const store = get();
    const dateKey = moment(user.createdAt).format("YYYY-MM-DD");

    const daysData = { ...store.daysData };
    const stats = { ...store.stats };

    if (!daysData[dateKey]) return;

    const isPaid = isPaidUser(user);

    if (isPaid) {
      daysData[dateKey].payUsers--;
      stats.paid--;
    } else {
      daysData[dateKey].unpayUsers--;
      stats.unpaid--;
    }

    daysData[dateKey].totalUsers--;
    stats.total--;

    set({ daysData, stats });
  }
}));

export const useUsageChartData = create()((set, get) => ({
  daysData: {},
  setDaysData: (value) => set({ daysData: value }),
  stats: { total: 0, used: 0, unused: 0 },
  setStats: (value) => set({ stats: value }),
  chartData: [],
  setChartData: (value) => set({ chartData: value }),
  lastUserId: null,
  setLastUserId: (value) => set({ lastUserId: value }),
  loading: false,
  setLoading: (value) => set({ loading: value }),
  onReset: () => set((state) => ({
    daysData: {},
    stats: { total: 0, used: 0, unused: 0 },
    chartData: [],
    lastUserId: null,
    loading: false
  })),
  removeUserFromUsageStats: (user) => {
    const store = get();
    const dateKey = moment(user.createdAt).format("YYYY-MM-DD");

    const daysData = { ...store.daysData };
    const stats = { ...store.stats };

    if (!daysData[dateKey]) return;

    if (isUsageUser(user)) {
      daysData[dateKey].usedUsers--;
      stats.used--;
    } else {
      daysData[dateKey].unusedUsers--;
      stats.unused--;
    }

    daysData[dateKey].totalUsers--;
    stats.total--;

    set({ daysData, stats });
  }
}));
